import { CustomGroupPost, CustomGroupUpdate } from '../../models/custom-group';
import { ObjectSchema, array, number, object, string, boolean } from 'yup';

export const MAX_CUSTOM_GROUPS = 50;
export const CUSTOM_GROUP_MAX_CHANNELS = 50;

export function CustomGroupValidator(): ObjectSchema<CustomGroupPost> {
    return object({
        groupName: string().trim().required().nonNullable(),
        description: string(),
        channels: array()
            .ensure()
            .max(CUSTOM_GROUP_MAX_CHANNELS)
            .of(
                object({
                    fcuChannelId: number().integer().required().nonNullable(),
                    name: string().trim().required().nonNullable(),
                    channelId: string().trim().required().nonNullable(),
                })
                    .required()
                    .nonNullable()
                    .noUnknown()
                    .strict(),
            )
            .required(),
        publicAccess: boolean().required().nonNullable(),
    })
        .noUnknown()
        .strict() as ObjectSchema<CustomGroupPost>; //Type casted because there's a bug with required types in arrays
}

export function CustomGroupUpdateValidator(): ObjectSchema<CustomGroupUpdate> {
    return object({
        groupName: string().trim().required().nonNullable(),
        id: string().trim().required().nonNullable(),
        description: string(),
        channels: array()
            .ensure()
            .max(CUSTOM_GROUP_MAX_CHANNELS)
            .of(
                object({
                    fcuChannelId: number().integer().required().nonNullable(),
                    name: string().trim().required().nonNullable(),
                    channelId: string().trim().required().nonNullable(),
                })
                    .required()
                    .nonNullable()
                    .noUnknown()
                    .strict(),
            )
            .required(),
        publicAccess: boolean().required().nonNullable(),
    })
        .noUnknown()
        .strict() as ObjectSchema<CustomGroupUpdate>; //Type casted because there's a bug with required types in arrays
}
